export const GET_PROCESSES = () => `/processcustom/resource`;
export const GET_PROCESSES_COUNT = () => `/processcustom/resource/count`;

export const GET_UNIPILE_ACCOUNTS = () => `/unipile/accounts`;
export const SYNC_FETCH_UNIPILE_ACCOUNTS = () => `/unipile/accounts/sync`;
export const DELETE_UNIPILE_ACCOUNT = (id: string) => `/unipile/accounts/${id}`;
export const GET_UNIPILE_ACCOUNT_LINK = () => `/unipile/accounts/link`;
export const GET_UNIPILE_PROVIDER_ID = () => `/unipile/provider_id`;
